<template>
  <div class="app-container bj-label-colon label-width-7 bj-el-input-disabled app-container-2022-2-9-11-42-08">
    <div class="tabs isFixed">
      <div class="tabs-btn" v-if="$route.query.type!='waveDetail'">
        <!-- 编辑 -->
        <el-button v-if="$route.query.type=='edit' && ![7,8].includes(routeStatus) && ![0,2,3,5].includes(routeOrderHandleStatus) && !isUrgent && $route.query.tabName != 'waitHunter'" :disabled="suspendStatus=='21201'" type="primary" @click="onEditOrder">{{ $t('editText') }}</el-button>
        <!-- 取消订单 -->
        <el-button v-if="(orderInfoVO.orderStatus == 0 || orderInfoVO.orderStatus == 3)
          && (orderInfoVO.sapOrderStatus!=1 || orderInfoVO.sapOrderStatus!=2)
          && ![7,8].includes(routeStatus) && ![0,2,3,5].includes(routeOrderHandleStatus)
          && !isUrgent && $route.query.tabName != 'waitHunter' "
           type="primary" @click="onCancel">{{ $t('InternalSalesOrderDetails.Cancel') }}</el-button>
        <!-- 提货 -->
        <el-button v-if="![0,2,3,5].includes(routeOrderHandleStatus) && !isUrgent && $route.query.tabName != 'waitHunter'" :disabled="!([5,7].includes(routeStatus) && orderInfoVO.takingDeliveryWay == 1)" type="primary" class="main-btn" @click="customerDelivery">{{ $t('InternalSalesOrderDetails.customerDelivery') }}</el-button>
        <!-- 日志 -->
        <BjLogButton type="order" :default-query="{
          innerOrderNo: orderInfoVO.innerOrderNo,
          copyOrigin: orderInfoVO.copyOrigin,
          isUser: true,
        }" no-permission :title="orderInfoVO.innerOrderNo" api="orderApi" />
        <!-- 返回 -->
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </div>
      <div class="tabs-btn" v-else>
        <!-- 返回 -->
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </div>
    </div>
    <div :class="{ 'isFixed2': isFixed }" class="tabs">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane v-for="item in catalogue" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs>
    </div>
    <div id="placeholderTabs" class="placeholder-tabs"></div>
    <!-- 1、 物流信息 ==>> 预占超时 特殊展示此模块，下面的物流信息模块隐藏，在非预占超时时展示 -->
    <!-- 2、 路由中取值operationType：1.推送异常，0.预占超时 -->
    <template v-if="this.$route.query.operationType==1">
      <BjDivider id="logisticsInfo1">{{ this.$t('InternalSalesOrderDetails.Logistics') }} </BjDivider>
      <div class="bj-row mt20">
        <LogisticsTable ref="LogisticsInfo" has-btn :show-enquiry="showEnquiry" :data-info="info" :tabIndex="'2'"/>
      </div>
    </template>

    <BjDivider id="orderInfo">{{ this.$t('InternalSalesOrderDetails.Orderinformation') }}
      <!-- 修正异常单、选择修正方式、重新推送 只有在推送异常的状态开放-->
      <template #right v-if="operationType==1">
        <el-button type="primary" v-if="!cascaderShow" @click="onEditOptions">{{ $t('InternalSalesOrderDetailsSearchTable.Fix') }}</el-button>
        <el-cascader v-if="cascaderShow" v-model="cascaderValue" :options="cascaderOptions" :placeholder="$t('InternalSalesOrderDetailsSearchTable.Select')" @change="cascaderChange"></el-cascader>
        <el-button type="primary" v-if="cascaderShow" @click="pushAgain()">{{ $t('InternalSalesOrderDetailsSearchTable.push') }}</el-button>
      </template>
    </BjDivider>

    <!-- 1、 订单异常原因展示，只有 推送异常 才有这个模块 -->
    <!-- 2、 路由中取值operationType：1.推送异常，0.预占超时 -->
    <div class="bj-row mt20" v-if="this.$route.query.operationType==1">
      <template>
        <div class="bj-col bj-col-24 circulation-status">
          <div class="el-icon-circle">
            <i class="el-icon-warning-outline"></i>
          </div>
          <div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.typeE') }}</div>
              <div class="bj-form-item-value">{{ orderErrorType }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.reasonE') }}</div>
              <div class="bj-form-item-value">{{ orderErrorReason }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.Suggestions') }}</div>
              <div class="bj-form-item-value">{{ exceptionSuggest }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- 1、 标签 ==>> 预占超时 不展示此模块 -->
    <!-- 2、 路由中取值operationType：1.推送异常，0.预占超时 -->
    <div v-if="orderInfoVO.tags && this.$route.query.operationType!=1" class="bj-row mt20 tags">
      <!-- <BjTagList :tag-code-array="cptOrderTagCodeList" closable @close="handleCloseTag">
        <el-button @click="onAddTags">{{ $t('InternalSalesOrderDetails.Add') }}</el-button>
      </BjTagList> -->
      <BjTagList :tag-code-array="cptOrderTagCodeList"></BjTagList>
    </div>

    <!-- 订单信息 -->
    <div class="bj-row mt20 padding-no fix">
      <!-- 基础信息 -->
      <div class="bj-col bj-col-12">
        <div class="bj-form-title">
          {{ $t('InternalSalesOrderDetails.Basic') }}
          <span v-if="operationType==1" class="link right" @click="OrderAbnormal">{{ $t('InternalOrder.form.AbnormalCause') }}</span>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.type') }}</div>
          <div class="bj-form-item-value">
            {{ $t(ORDER_BUSINESS_TYPE_LIST.bjGet(orderInfoVO.businessType)) }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Order') }}</div>
          <div class="bj-form-item-value">
            {{ $t(ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(totalOrderStatus)) }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.party') }}</div>
          <div class="bj-form-item-value">
            <span class="link" @click="$toBusinessThirdOrderView(orderInfoVO.outerOrderNo)">{{ orderInfoVO.webReference }}</span>
            <BjCopyIcon :copy="orderInfoVO.webReference" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalOrder.form.wmsOrderNo') }}</div>
          <div class="bj-form-item-value">
            <span>{{ orderInfoVO.sapOrderNo }}</span>
            <BjCopyIcon :copy="orderInfoVO.sapOrderNo" />
          </div>
        </div>
        <div class="bj-form-item" v-if="orderInfoVO.storeCode == 'CO00000658'">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.dodgeCompany') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.ecommerceOrderRef}}</div>
        </div>
        <div class="bj-form-item" v-if="orderInfoVO.storeCode == 'CO00000658'">
          <div class="bj-formItemLabel">{{ $t('DetailsOfThirdPartySalesOrder.dodgeAccount') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.siteListingId}}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Store') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.storeName }}
            <span class="F68710">（{{ SCHL_CHANNEL_TYPE.bjGet(orderInfoVO.channel) }}）</span>
          </div>
          <!-- <span v-if="$route.query.status!='3'" class="bj-form-item-right link ml5" @click="getLogistics">{{ $t('queryText') }}</span> -->
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Three') }}</div>
          <div class="bj-form-item-value">{{ orderInfoVO.orderTime | timeFilters(orderInfoVO.orderTime) }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.creation') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.creationDate | timeOperateTwoHour }}
          </div>
        </div>
        <!-- 送货预约时间：仅 CSG MANUAL 展示 -->
        <div v-if="orderInfoVO.shippingMethod === 'CSG MANUAL'" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('BusinessThirdOrderAdd.deliveryAppointmentTime') }}</div>
          <div class="bj-form-item-value">
            {{ orderInfoVO.deliveryAppointmentTime | timeFilters(orderInfoVO.deliveryAppointmentTime) }}
          </div>
        </div>
        <!-- <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Buyer') }}</div>
          <el-tooltip class="bj-form-item-value" effect="dark" :content="orderInfoVO.buyerRemarks" placement="top-start">
            <span class="ellipsis">{{ orderInfoVO.buyerRemarks }}</span>
          </el-tooltip>
          <div v-if="!orderInfoVO.sapPushTime" class="bj-form-item-right link ml5" @click="OrderRemarks('buyerRemarks')">{{ $t('InternalSalesOrderDetails.Modify') }}</div>
        </div> -->
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Merchant') }}</div>
          <div class="bj-form-item-value order-remark-content">
            <el-tooltip effect="dark" :content="orderInfoVO.orderRemarks" :disabled="!orderInfoVO.orderRemarks" placement="top-start" popper-class="csg-order-remark-tooltip">
              <span class="ellipsis order-remark-text">{{ orderInfoVO.orderRemarks }}</span>
            </el-tooltip>
            <BjCopyIcon v-if="orderInfoVO.orderRemarks" class="link order-remark-copy" :copy="orderInfoVO.orderRemarks" />
          </div>
          <div v-if="!orderInfoVO.sapPushTime" class="bj-form-item-right link" style="font-size: 14px" @click="OrderRemarks('orderRemarks')">{{ $t('InternalSalesOrderDetails.Modify') }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.Customer') }}</div>
          <div class="bj-form-item-value order-remark-content">
            <el-tooltip effect="dark" :content="orderInfoVO.serviceRemarks" :disabled="!orderInfoVO.serviceRemarks" placement="top-start" popper-class="csg-order-remark-tooltip">
              <span class="ellipsis order-remark-text">{{ orderInfoVO.serviceRemarks }}</span>
            </el-tooltip>
            <BjCopyIcon v-if="orderInfoVO.serviceRemarks" class="link order-remark-copy" :copy="orderInfoVO.serviceRemarks" />
          </div>
          <div v-if="$route.query.type!='waveDetail'" class="bj-form-item-right link" style="font-size: 14px" @click="OrderRemarks('serviceRemarks')">
            {{ $t('InternalSalesOrderDetails.Modify') }}
          </div>
        </div>
        <!-- 是否指定物流 -->
        <div v-if="orderInfoVO.shippingMethod !== 'CSG MANUAL'&&operationType==1 && routeStatus !== 3" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.isLogisticsSpecified') }}</div>
          <div class="bj-form-item-value">
            <el-switch v-model="info.isLogisticsSpecified" active-color="#082dc3" inactive-color="" @change="offSwitch"></el-switch>
          </div>
        </div>
        <!-- 选择物流信息 -->
        <div v-if="(orderInfoVO.shippingMethod == 'CSG MANUAL'||orderInfoVO.shippingMethod == 'CUSTOMER MANUAL')&&info.isLogisticsSpecified" class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.chooseLogistics') }}</div>
          <div class="bj-form-item-value">
            <span v-if="operationType!=1">{{ orderInfoVO.logisticsName }}</span>
            <BjSelectLov v-else v-model="orderInfoVO.logisticsName" :option-list="LogisticsSelectionData" :clearable="false" @change="logsome" />
          </div>
        </div>
        <!-- shipping method -->
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('BusinessPurchaseOrder2.means') }}</div>
          <div class="bj-form-item-value">
              {{ info.isLogisticsSpecified && orderInfoVO.logisticsName ? orderInfoVO.shippingMethod + ' (' + orderInfoVO.logisticsName + ')' : orderInfoVO.shippingMethod }}
          </div>
        </div>
        <!-- 附件 -->
        <template>
          <div class="file">
            <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Supporting') }}:</div>
            <div class="fileUpload">
              <div v-for="(item, index) in info.orderInfoVO.orderMaterialList" :key="index" class="fileUpload_right">
                <div class="ellipsis link" @click="downloadImageUrl(item.fileUrl, item.fileName)"><span>file{{ index + 1 }}: </span> {{ item.fileName }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 买家及收货信息(新) operationType : 1.推送异常，0.预占超时 -->
      <buyerInfoDialog :receiver-info-v-o="info.receiverInfoVO" :is-show-edit="operationType==1 || (routeStatus === 8&&orderInfoVO.shippingMethod == 'CSG MANUAL'&&$route.query.type=='edit')" @saveReceiverInfo="saveReceiverInfo" />
      <!-- 买家及收货信息(旧) operationType : 1.推送异常，0.预占超时 -->
      <!-- <receivingInformation :receiver-info-v-o="info.receiverInfoVO" :is-show-edit="operationType==1" :is-reciver-edit="isReciverEdit" @onEditReceiverInfo="onEditReceiverInfo" @saveReceiverInfo="saveReceiverInfo" @cancelReceiverInfo="cancelReceiverInfo" /> -->
    </div>
    <!-- 物流单 -->
    <template>
      <BjDivider id="shippingLabel"> {{ $t('InternalSalesOrderDetails.shippingLabel') }}
        <!-- 打印 -->
        <template #right v-if="$route.query.type!='waveDetail'">
          <el-button type="primary" @click="onPrint()">{{ $t('printText') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-row mt20">
        <div class="bj-col bj-col-12">
          <div class="bj-form-title" v-if="$route.query.type!='waveDetail'">
            <!-- logisticsStatus：1.未关单 2.已关单 -->
            <!-- 物流标签shippingLabels存在 可以点击 下载按钮-->
            <span v-if="info.orderInfoVO.shippingLabels && info.orderInfoVO.shippingLabels.length>0" class="link right" style="margin-left:10px;" @click="batchDownLoad">{{ $t('downloadText') }}</span>
            <!-- 物流状态未关单 并且 物流标签shippingLabels存在 ==》 可以点击 关单按钮-->
            <span v-if="logisticsInfoObj.logisticsStatus == 1 && (info.orderInfoVO.shippingLabels && info.orderInfoVO.shippingLabels.length>0)" class="link right" style="margin-left:10px;" @click="closeOrder">{{ $t('InternalSalesOrderDetails.closeOrder') }}</span>
            <!-- (订单状态不是 缺货、完成、等待取货、等待发货 并且 没有点击修改 并且 物流未关单) 或者 (订单状态为等待发货 并且 是编辑状态 并且 没有点击修改)  ==》 可以点击 修改按钮 -->
            <span v-if="(![4,5,7,8].includes(routeStatus) &&!isOrderInfoVOEdit && logisticsInfoObj.logisticsStatus != 2)||(routeStatus === 8 && $route.query.type == 'edit' && !isOrderInfoVOEdit )" class="link right" style="margin-left:10px;" @click="showOrderInfoVOEdit">{{ $t('InternalSalesOrderDetails.Modify') }}</span>
            <span v-if="isOrderInfoVOEdit" class="link right" style="margin-left:10px;" @click="saveShippingLabelInfo">{{ $t('saveText') }}</span>
            <span v-if="isOrderInfoVOEdit" class="link right" @click="isOrderInfoVOEdit = false">{{ $t('cancelText') }}</span>
          </div>
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('BusinessPurchaseOrder2.means') }}</div>
            <div class="bj-form-item-value">
              <div class="bj-col-12">
                <span v-if="!isOrderInfoVOEdit">{{ orderInfoVO.shippingMethod }}</span>
                <BjSelectLov v-else v-model="orderInfoVO.shippingMethod" :disabled="true" :option-list="CSG_ORDER_SHIPPING_METHODS" />
              </div>
            </div>
          </div>
          <template v-if="orderInfoVO.shippingMethod === 'CSG MANUAL' || orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'">
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('InternalReturnRefundNoteDetails.Logistics') }}</div>
              <div class="bj-form-item-value">
                <div class="bj-col-12">
                  <span v-if="!isOrderInfoVOEdit">{{ logisticsInfoObj.logisticsBusinessName }}</span>
                  <BjSelectLov v-else v-model="logisticsInfoObj.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="changeLogistics" />
                </div>
              </div>
            </div>
            <div class="bj-form-item" v-if="orderInfoVO.shippingMethod === 'CSG MANUAL'">
              <div class="bj-formItemLabel">{{ $t('billingPage.Carrie') }}{{ $t('BusinessOrderAuditComSkuList.transPrice') }}</div>
              <div class="bj-form-item-value">
                <div class="bj-col-12">
                  <span v-if="!isOrderInfoVOEdit">{{ logisticsInfoObj.totalPrice }}</span>
                  <BjInputMoney v-else v-model="logisticsInfoObj.totalPrice" clearable />
                </div>
              </div>
            </div>
            <div class="bj-form-item">
              <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.logisticsNo') }}</div>
              <div class="bj-form-item-value">
                <div class="bj-col-12">
                  <span v-if="!isOrderInfoVOEdit">{{ logisticsInfoObj.logisticsNo }}</span>
                  <BjInput v-else v-model="logisticsInfoObj.logisticsNo" clearable />
                </div>
              </div>
            </div>
          </template>

          <!-- 物流单 -->
          <template v-if="!isOrderInfoVOEdit">
            <div class="file" style="line-height:1.5">
              <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Shipment') }}:</div>
              <div class="fileUpload">
                <div v-for="(item, index) in info.orderInfoVO.shippingLabels" :key="index" class="flex" style="color: #3173d0; cursor: pointer;">
                  <span>file{{ index + 1 }}:</span>
                  <div style="width: 350px;" class="ellipsis">
                    <span class="mr20">{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="font12">
              <div class="bj-formItemLabel">{{ $t('OrdinaryOrderMix.LogisticsTable.Shipment') }}:</div>
            </div>
            <div class="fileUpload2">
              <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange">
                <template slot="default">
                  <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
              </UploadFile>
            </div>
          </template>
        </div>
        <div class="bj-col bj-col-12">
          <div class="bj-form-title">
            {{ $t('WarehouseManagement.form.chooseLogistics') }}
          </div>
          <!-- 'CSG MANUAL' 审核报价 -->
          <div v-if="orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.isQuotation') }}</div>
            <div class="bj-form-item-value">
              <el-switch v-model="orderInfoVO.isNeedQuota" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </div>
          </div>
          <!-- 'CSG MANUAL' 报价金额 -->
          <div v-if="orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.amount') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjInputNumber v-model="orderInfoVO.quotedAmount" disabled clearable /> -->
              <div class="bj-form-item-value">{{ orderInfoVO.quotedAmount}} AUD</div>
            </div>
          </div>
          <!-- 'CSG MANUAL' 报价状态 -->
          <div v-if="orderInfoVO.shippingMethod=='CSG MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.quotationStatus') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjSelectLov v-model="orderInfoVO.quotaOrNot" disabled :option-list="quotationStatusList" /> -->
              <div class="bj-form-item-value">{{ quotationStatusList.bjGet(orderInfoVO.quotaOrNot)}}</div>
            </div>
          </div>

          <!-- 'CUSTOMER MANUAL' 是否需要仓库提供尺寸信息 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.check') }}</div>
            <div class="bj-form-item-value">
              <el-switch v-model="orderInfoVO.isProvideSize" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 尺寸是否填写 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.filled') }}</div>
            <div class="bj-form-item-value">
              <el-switch v-model="sizeIsFillIn" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 长 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Length')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repLength}} cm</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 宽 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Width')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repWidth}} cm</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 高 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Height')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repHeight}} cm</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 重 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'&&sizeIsFillIn" class="bj-form-item">
            <div class="bj-formItemLabel">{{$t('WarehouseManagement.form.Weight')}}</div>
            <div class="bj-form-item-value">
              <div class="bj-form-item-value">{{ orderInfoVO.repWeight}} kg</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 需要托盘数量 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.need') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjInputNumber v-model="orderInfoVO.palletQty" disabled clearable /> -->
              <div class="bj-form-item-value">{{ orderInfoVO.palletQty}}</div>
            </div>
          </div>
          <!-- 'CUSTOMER MANUAL' 预计取货时间 -->
          <div v-if="orderInfoVO.shippingMethod=='CUSTOMER MANUAL'" class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('WarehouseManagement.form.time') }}</div>
            <div class="bj-form-item-value">
              <!-- <BjDateTimerPicker v-model="orderInfoVO.truckPickupTime" disabled /> -->
              <div class="bj-form-item-value">{{ orderInfoVO.truckPickupTime | timeFilters(orderInfoVO.truckPickupTime) }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 图片信息 -->
    <BjDivider id="imgInfo" v-if="ImgData.length>0">{{ this.$t('InternalSalesOrderDetails.Image') }} </BjDivider>
    <div class="bj-row mt20" v-if="ImgData.length>0">
      <div class="bj-col bj-col-24 flex-align relative">
        <div v-for="(item,key) in pdfData" :key="key" style="position:absolute;top:0;left:0;font-size: 14px;">
          <a :href="`${item.detailImage}`" target='_blank' download style="color:#409eff">{{ $t('downloadText') + 'PDF'}}</a>
        </div>
        <div style="width:22%;margin:0 10px;" v-for="(item,key) in ImgData" :key="key">
          <BjKeyImage v-if="item.imageType == 'Signature' || item.imageType == 'OrderPdf'" width="100%" height="120px" url="https://minio.wooper.com/test/10/1728874350587_14T9R1MV.png" preview />
          <BjKeyImage v-else width="100%" height="200px" :url="checkUrl(item.detailImage)" preview />
        </div>
      </div>
    </div>
    <!-- 商品信息 -->
    <BjDivider id="goodsInfo">{{ this.$t('InternalSalesOrderDetails.Product') }} </BjDivider>
    <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <GoodsInfoTab v-if="tabVisible" ref="GoodsInfoTab" :order-id="id" :inner-order-no="orderInfoVO.innerOrderNo" :order-status="orderInfoVO.orderStatus" has-btn :business-type="businessType" @reFresh="reFresh" @afterFetchOriginalData="afterFetchOriginalData" />
      </div>
    </div>

    <!-- 物流信息 -->
    <template v-if="this.$route.query.operationType!=1">
      <BjDivider id="logisticsInfo2">{{ this.$t('InternalSalesOrderDetails.Logistics') }} </BjDivider>
      <div class="bj-row mt20">
        <LogisticsTable ref="LogisticsInfo" has-btn :show-enquiry="showEnquiry" :data-info="info" :tabIndex="'0'" />
      </div>
    </template>

    <!--  支付信息  -->
    <template v-if="routeStatus === 5 && paymentList.length>0">
      <BjDivider id="paymentInfo">{{ this.$t('InternalSalesOrderDetails.PaymentInfo') }} </BjDivider>
      <!--   卡片表格列表   -->
      <PaymentTableList :list="paymentList"></PaymentTableList>
    </template>

    <!-- 内部信息 -->
    <template>
      <BjDivider id="internInfo"> {{ $t('InternalSalesOrderDetails.internInfo') }}</BjDivider>
      <div class="bj-row mt20">
        <div class="bj-col bj-col-12">
          <!-- <div class="bj-form-title"></div> -->
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.WarehouseRemarks') }}</div>
            <div class="bj-form-item-value">
              <div class="bj-col-12">
                <span>{{ interninformation.warehouseComment }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bj-col bj-col-12">
          <!-- <div class="bj-form-title"></div> -->
          <div class="bj-form-item">
            <div class="bj-formItemLabel">{{ $t('InternalSalesOrderDetails.logisticsComment') }}</div>
            <div class="bj-form-item-value">
              <div class="bj-col-12">
                <span>{{ orderInfoVO.logisticsComment }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <EditRemarks :id="id" ref="EditRemarks" :info="orderInfoVO" @editBaseInfoApi="editBaseInfoApi" />
    <EditReceiverInfo :id="id" ref="EditReceiverInfo" :info="info.receiverInfoVO" @editBaseInfoApi="editBaseInfoApi" />
    <SuspendReason :id="id" ref="SuspendReason" @reFresh="reFresh" />
    <EditTags :id="id" ref="EditTags" :tags="cptOrderTagCodeList" @editBaseInfoApi="editBaseInfoApi" />
    <!--    物流业务弹窗-->
    <BjDialog :title="$t('routeBusinessStockDeliveryInformView.business')" :visible="logistics_visible" width="600px" @close="logistics_visible = false">
      <bj-table ref="BjTable" :loading="false" :list="dialogListConfig.columns" :serial="true" :is-pagination="false">
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="{ row }">
                <template v-if="false" />
                <el-switch v-else-if="col.prop === 'isEnable'" v-model="row[col.prop]" disabled></el-switch>
                <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </bj-table>
    </BjDialog>
    <el-dialog :title="$t('routeBusinessStockDeliveryInformView.go')" :visible.sync="isShow" width="500px" :before-close="handleClose">
      <div class="flex-align">
        <div v-for="(item,index) in viewData" :key="index" @click="goThirdView(item)"><el-link type="primary">{{ item }}</el-link>
          <span v-if="viewData.length-1!=index" style="color:black">，</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="goCopyPage()">{{ $t('InternalSalesOrderDetails.Resend') }}</el-button>
      </div>
    </el-dialog>
    <delveryDialog ref="delveryDialogRef" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewMiXin from '@/utils/view-mixin.js';
import { orderApi, channelApi, logisticApi, settingApi, billApi, stockApi} from '@/api';
import GoodsInfoTab from './GoodsInfoTab';
import delveryDialog from './delveryDialog';
import BjDialog from '@/packages/BjDialog';

import LogisticsTable from './LogisticsTable';
import EditRemarks from './EditRemarks';
import EditReceiverInfo from './EditReceiverInfo';
import SuspendReason from './SuspendReason';
import PaymentTableList from './paymentTable/paymentTableList';
import EditTags from '@/views/center-business/csgOrder/order/components/EditTags';
import receivingInformation from '@/components/order/receivingInformation';
import buyerInfoDialog from '@/components/order/buyerInfoDialog';
import UploadFile from '@/views/center-business/third/csg/order/components/UploadFile';
import { events_config } from '@/utils';

import {
  ORDER_TRADE_TYPE_LIST,
  ORDER_BUSINESS_TYPE_LIST,
  ORDER_ACTION_TYPE_LIST,
  STATUS_HAVE_TRUE,
  ORDER_INTERNAL_ALL_STATUS_LIST,
  ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SOURCE_STATUS_LIST,
  //
  ORDER_INTERNAL_PAYMENT_LIST,
  ORDER_INTERNAL_PAYMENT_STATUS_LIST,
  ORDER_DECRYPT_NAME,
} from '@/utils/constants';
import { getOffsetTop } from '@/utils';
import BjInputMoney from '@/packages/BjInputMoney';
const DUPLICATE_TRACKING_CODE = 'Tracking number already exists. It may be a combined shipment. Please verify before adding.';
const getDefaultForm = () => {
  return {
    orderStatusTotalVO: {
      finishCount: null,
      unfinishedCount: null,
      cancelCount: null,
    },
    unfinishedTotalVO: {
      outStockCount: null,
      failSeekCount: null,
      waitSendCount: null,
      preempAuditCount: null,
      seekAuditCount: null,
    },
    waitDealTotalVO: {
      outStockCount: null,
      failSeekCount: null,
      failSyncPreempCount: null,
      failSyncSendCount: null,
      waitAudit: null,
    },
    orderInfoVO: {
      id: null,
      orderStatus: null,
      tradeType: null,
      outerOrderNo: null,
      innerOrderNo: null,
      storeName: null,
      storeCode: null,
      orderTime: null,
      creationDate: null,
      deliveryAppointmentTime: null,
      orderRemarks: null,
      buyerRemarks: null,
      serviceRemarks: null,
      shippingMethod: null,
      shippingLabels: [],
      logisticsBusinessName: null,
      totalPrice: null,
      isProvideSize: false,
      palletQty: null,
      truckPickupTime: null,
    },
    receiverInfoVO: {
      buyerNick: null,
      receiverName: null,
      phone: null,
      mobile: null,
      province: null,
      city: null,
      district: null,
      address: null,
    },
    amountInfoVO: {
      goodsTotalAmount: null,
      buyerPayAmount: null,
      costAmount: null,
    },
    paymentInfoVO: {
      payType: null,
      payStatus: null,
      payTime: null,
      payAmount: null,
    },
    interninformation: {
      warehouseComment: null,
    },
  };
};

export default {
  name: 'BusinessOrderInternalViewForm',
  components: {
    BjInputMoney,
    GoodsInfoTab,
    delveryDialog,
    LogisticsTable,
    PaymentTableList,
    EditRemarks,
    EditReceiverInfo,
    SuspendReason,
    EditTags,
    BjDialog,
    receivingInformation,
    buyerInfoDialog,
    UploadFile
  },
  mixins: [viewMiXin, pageMiXin],
  props: {
    businessType: {
      type: String,
      default: '',
    },
  },
  provide() {
    return { getInfo: () => this.info };
  },
  data() {
    return {
      ORDER_TRADE_TYPE_LIST,
      ORDER_BUSINESS_TYPE_LIST,
      ORDER_ACTION_TYPE_LIST,
      STATUS_HAVE_TRUE,
      ORDER_INTERNAL_ALL_STATUS_LIST,
      ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      //
      ORDER_INTERNAL_PAYMENT_LIST,
      ORDER_INTERNAL_PAYMENT_STATUS_LIST,
      ORDER_DECRYPT_NAME,

      info: getDefaultForm(),
      // 表单校验
      rules: {},
      activeName: 'orderInfo',
      isFixed: false,
      tabVisible: true,
      logistics_visible: false,
      dialogListConfig: {
        columns: []
      },
      labelList: [
        { label: 'businessLogisticsCompany.table.status', prop: 'isEnable', isCheck: true, disabled: false, width: 150 },
        { label: 'businessLogisticsCompany.table.logisticsCompanyName', prop: 'logisticsName', isCheck: true, disabled: false },
      ],
      // 物流列表信息
      LogisticsSelectionData: [],
      // 外部订单号弹窗开关
      isShow: false,
      // 外部订单号弹窗信息
      viewData: [],
      isReciverEdit: false,
      isOrderInfoVOEdit: false,
      fileList: [],
      manual: ['CUSTOMER MANUAL', 'PICKUP', 'CSG MANUAL'],
      CSG_ORDER_SHIPPING_METHODS: [
        {value: 'CSG MANUAL', label: 'CSG MANUAL BOOKING'},
        {value: 'CUSTOMER MANUAL', label: 'CUSTOMER MANUAL BOOKING'},
      ],
      logisticsInfoObj: {}, // shipping label 临时存放的 发货单信息
      copyReceiverInfo: {},
      operationType: this.$route.query.operationType || null,
      suspendStatus: '21200',
      // 订单总状态
      totalOrderStatus: '',
      // 图片信息
      ImgData: [],
      pdfData: [],
      // 报价状态
      quotationStatusList:[
        {value: 0, label: this.$t('WarehouseManagement.form.status0')},
        {value: 1, label: this.$t('WarehouseManagement.form.status1')},
        {value: 2, label: this.$t('WarehouseManagement.form.status2')},
        {value: 3, label: this.$t('WarehouseManagement.form.status3')},
      ],
      // 尺寸是否填写
      sizeIsFillIn:false,
      // 支付信息列表
      paymentList: [],
      totalPriceDeep:null,
      // 订单异常类型
      orderErrorType:null,
      // 订单异常原因
      orderErrorReason:null,
      // 订单异常操作建议
      exceptionSuggest:null,
      // 异常订单处理级联框 v-if
      cascaderShow:false,
      // 异常订单处理级联框 Value
      cascaderValue:[],
      // 异常订单处理级联框 Options
      cascaderOptions: [{
        value: '1',
        label: this.$t('InternalSalesOrderDetails.toCSGMANUAL'),
      }, {
        value: '2',
        label: this.$t('InternalSalesOrderDetailsSearchTable.Requote'),
      }, {
        value: '3',
        label: this.$t('InternalSalesOrderDetailsSearchTable.Choose'),
        disabled: false,
        children: []
      }],
      // 异常订单处理展示字段
      actionName:null,
    };
  },
  computed: {
    routeStatus() {
      const status = this.$route.query.status;
      if (status === undefined || status === null || status === '') return null;
      const value = Number(status);
      return Number.isNaN(value) ? null : value;
    },
    routeOrderHandleStatus() {
      const status = this.$route.query.orderHandleStatus;
      if (status === undefined || status === null || status === '') return null;
      const value = Number(status);
      return Number.isNaN(value) ? null : value;
    },
    showEnquiry() { // csg manual物流信息不显示 询价结果
      return this.orderInfoVO.shippingMethod === 'CSG MANUAL';
    },
    catalogue() {
      const catalogue = [
        { id: 'logisticsInfo1', name: this.$t('InternalSalesOrderDetails.Logistics') },
        { id: 'orderInfo', name: this.$t('InternalSalesOrderDetails.Orderinformation') },
        { id: 'shippingLabel', name: this.$t('InternalSalesOrderDetails.shippingLabel') },
        { id: 'goodsInfo', name: this.$t('InternalSalesOrderDetails.Product') },
        { id: 'logisticsInfo2', name: this.$t('InternalSalesOrderDetails.Logistics') },
        { id: 'internInfo', name: this.$t('InternalSalesOrderDetails.internInfo') }
      ];
      if(this.$route.query.operationType==1){
        const idx = catalogue.findIndex(item => item.id === 'logisticsInfo2');
        if(idx !== -1) catalogue.splice(idx, 1);
      } else {
        const idx = catalogue.findIndex(item => item.id === 'logisticsInfo1');
        if(idx !== -1) catalogue.splice(idx, 1);
      }
      const payArr = [{ id: 'paymentInfo', name: this.$t('InternalSalesOrderDetails.PaymentInformation') }]
      if (this.routeStatus === 5) {
        return [...catalogue, ...payArr]
      }else{
        return catalogue;
      }
    },
    id() {
      return this.info.orderInfoVO.id;
    },
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
    BJ_TAGS() {
      return this.$store.state.values.BJ_TAGS || [];
    },
    percentage() {
      const done =
        this.orderStatusTotalVO.finishCount || 0 + this.orderStatusTotalVO.cancelCount || 0;
      const all = done + this.orderStatusTotalVO.unfinishedCount || 0 || 1; // 0 不能为除数，默认为1
      return Math.floor(done / all * 100);
    },
    orderStatusTotalVO() {
      return this.info.orderStatusTotalVO || {};
    },
    unfinishedTotalVO() {
      return this.info.unfinishedTotalVO || {};
    },
    waitDealTotalVO() {
      return this.info.waitDealTotalVO || {};
    },
    orderInfoVO() {
      return this.info.orderInfoVO || {};
    },
    amountInfoVO() {
      return this.info.amountInfoVO || {};
    },
    paymentInfoVO() {
      return this.info.paymentInfoVO || {};
    },
    interninformation() {
      return this.info.interninformation || {};
    },
    cptOrderTagCodeList() {
      return this.orderInfoVO.tags ? this.orderInfoVO.tags.split(',') : [];
    },
    isUrgent() {
      return this.cptOrderTagCodeList.includes('LB1718612626520-1753039007');
    },
  },
  watch: {},
  created() {
    // 会被接口数据覆盖
    this.orderInfoVO.businessType = this.businessType;
    this.getLogisticsDataList();
    events_config.cancel('getDataOfSearchEvent', false);
    this.totalOrderStatus = this.routeStatus;
    // 推送异常，调用
    if(this.$route.query.operationType==1){
      this.getReason();
      this.getLogisticsList();
    }
  },
  mounted() {
    this.reFresh();
    this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');
    // 对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
    window.addEventListener('scroll', this.scrollCallBack, true);
    events_config.listen('getLogisticsEvent', (data, data2) => {
      this.logisticsInfoObj = data2;
      this.logisticsInfoObj.totalPrice = data2.totalCharge;
      this.totalPriceDeep = JSON.parse(JSON.stringify(data2.totalCharge));
    });
  },
  destroyed() {
    // 解绑滚轮监听事件
    window.removeEventListener('scroll', this.scrollCallBack, true);
  },
  methods: {
    // BjKeyImage 组件网址过滤
    checkUrl(url) {
      if (url) {
        if (String(url).indexOf('http') > -1) {
          return url;
        } else {
          return 'https://' + url;
        }
      }
    },
    // 打印文件前过滤（根据后端返回url获取文件并转化为文件流）
    async urlToFileStream(url, fileName, mimeType) {
      try {
        // 1. 使用 fetch 获取文件数据
        const response = await fetch(url);
        if (!response.ok) { throw new Error(`HTTP 请求失败，状态码: ${response.status}`);}
        // 2. 将响应转换为 Blob 对象
        const blob = await response.blob();
        // 3. 可选：指定文件名和 MIME 类型（如果未提供，则从响应头或 URL 推断）
        const inferredMimeType = mimeType || blob.type || 'application/octet-stream';
        const inferredFileName = fileName || url.split('/').pop() || 'download';
        // 4. 返回 File 对象（Blob 的子类，多了文件名属性）
        return new File([blob], inferredFileName, { type: inferredMimeType });
      } catch (error) {
        console.error('转换失败:', error);
        throw error;
      }
    },
    // 打印 物流单 
    onPrint(){
      orderApi.getOrderLabel({
        innerOrderNo:  this.$route.query.code,
      }).then(res => 	{
        console.log(res,'res');
        if (!res.failed) {
          this.$message.success(this.$t('screenWMS.ps3'));
          // 从网址转化为文件流 （接口数据， 文件名称  ，文件类型）
          this.urlToFileStream(res.message, this.$route.query.code, 'application/pdf')
            .then(file => {
              // console.log('文件流对象:', file);
              const url = URL.createObjectURL(file);
              const iframe = document.createElement('iframe');
              iframe.style.visibility = 'hidden';
              iframe.style.position = 'absolute';
              iframe.style.width = '0';
              iframe.style.height = '0';
              iframe.src = url;
              document.body.appendChild(iframe);
              iframe.onload = () => {
                iframe.contentWindow.print();
              };
            })
            .catch(err => console.error('错误:', err))
          // setTimeout(() => {
          //   window.open(res.message,'_blank')
          // }, 500);
        }
      })
    },
    onEditOptions(){
      this.cascaderShow=true
      this.cascaderValue = ["1"]
      this.actionName = this.$t('InternalSalesOrderDetails.toCSGMANUAL')
      console.log(this.cascaderValue);
    },
    // 获取异常订单原因
    getReason() {
      orderApi.getOrderErrorReason({
        innerOrderNo:  this.$route.query.code,
        operationType: this.$route.query.operationType,
      }).then(res => 	{
        this.orderErrorType=res.exceptionType
        this.orderErrorReason=res.exceptionReason
        this.exceptionSuggest=res.exceptionSuggest
      })
    },
    // 获取 异常订单处理级联框 > 指定物流公司 数据
    getLogisticsList() {
      stockApi.gateWayRating({orderCode: this.$route.query.code || null,versionCSG:null}).then(res => {
        if (Array.isArray(res)) {
          if(res.some(item => item.hasOwnProperty('provider'))){
            this.cascaderOptions[2].disabled = false
            this.cascaderOptions[2].children = res.map(item => {
              return { label: item.provider, value: item.provider };
            });
          }else{
            this.cascaderOptions[2].disabled = true
          }
        }
      });
    },
    // 异常订单处理级联框
    cascaderChange(value){
      console.log(this.cascaderValue);
      if(value[0]==1){
        this.actionName = this.$t('InternalSalesOrderDetails.toCSGMANUAL')
      }else if(value[0]==2){
        this.actionName = this.$t('InternalSalesOrderDetailsSearchTable.Requote')
      }else if(value[0]==3){
        this.actionName = `${this.$t('InternalSalesOrderDetailsSearchTable.Choose')} / ${value[1]}`
      }
    },
    // 重新推送之前三选一操作
    pushAgain() {
      this.$confirm(`${this.$t('InternalSalesOrderDetailsSearchTable.Confirm')} ${this.actionName} ?`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('yesText'),
        cancelButtonText: this.$t('noText'),
        type: 'warning'
      }).then(() => {
        if(this.cascaderValue[0]==1){
          this.toCSGMANUAL(this.info.orderInfoVO.innerOrderNo)
        }else if(this.cascaderValue[0]==2){
          this.toPriceSearch(this.info.orderInfoVO.innerOrderNo)
        }else if(this.cascaderValue[0]==3){
          this.bandLogistic(this.info.orderInfoVO.innerOrderNo,this.cascaderValue[1])
        }
      }).catch(() => {
        this.cascaderValue=[]
        this.cascaderShow=false
      });
    },
    // 一键改为 CSG MANUAL
    toCSGMANUAL(value) {
      orderApi.changeOrderErrorType({innerOrderNo: value,handleOrderExceptionType:1}).then(res => {
        if (res.failed === false) {
          // 操作成功后调用 重新推送 方法
          // this.endPush(value)
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.cascaderValue=[]
            this.cascaderShow=false
            this.reFresh();
          }, 500);
        }
      });
    },
    // 重新询价
    toPriceSearch(value) {
      orderApi.changeOrderErrorType({innerOrderNo: value,handleOrderExceptionType:2}).then(res => {
        if (res.failed === false) {
          // 操作成功后调用 重新推送 方法
          // this.endPush(value)
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.cascaderValue=[]
            this.cascaderShow=false
            this.reFresh();
          }, 500);
        }
      });
    },
    // 指定物流公司
    bandLogistic(value1,value2) {
      orderApi.changeOrderErrorType({innerOrderNo: value1,handleOrderExceptionType:3,provider:value2}).then(res => {
        if (res.failed === false) {
          // 操作成功后调用 重新推送 方法
          // this.endPush(value1)
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.cascaderValue=[]
            this.cascaderShow=false
            this.reFresh();
          }, 500);
        }
      });
    },
    // 重新推送
    // endPush(value) {
    //   settingApi.InstancesRePush({ innerOrderNo: value }).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.cascaderValue=[]
    //         this.cascaderShow=false
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    // 获取支付信息
    getPaymentInfo() {
      billApi.getTransactionInfos({
        clientCode: this.info.orderInfoVO.clientCode,
        orderId:  this.info.orderInfoVO.outerOrderNo,
        orderDate: this.info.orderInfoVO.hjShipmentTime
      }).then(res => 	{
        if (!res.failed) {
          this.paymentList = res.data;
        }
      })
    },
    getImg() {
      orderApi.getThirdOrderDetailImg({outOrderNo: encodeURIComponent(this.info.orderInfoVO.outerOrderNo)}).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.ImgData = res.filter(item=> item.imageType != 'OrderPdf')
          this.pdfData = res.filter(item=> item.imageType == 'OrderPdf')
        }
      });
    },
    changeLogistics(val, row) {
      this.logisticsInfoObj.logisticsCompany = row.label;
    },
    batchDownLoad() {
      this.info.orderInfoVO.shippingLabels.forEach(item => {
        this.downloadImageUrl(item.url, item.name);
      });
      //  0未下载 1已下载未关单 2已下载已关单
      if (this.logisticsInfoObj.logisticsStatus != 2) {
        this.logisticsInfoObj = {
          ...this.logisticsInfoObj,
          // logisticsStatus: this.logisticsInfoObj.logisticsStatus == 1 ? 2:1,
          innerOrderNo: this.info.orderInfoVO.innerOrderNo
        };
        this.$confirm(this.$t('InternalSalesOrderDetails.closeOrderTip'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('yesText'),
          cancelButtonText: this.$t('noText'),
          type: 'warning'
        }).then(() => {
          this.logisticsCsgApi({id: this.logisticsInfoObj.id, logisticsStatus: 2, innerOrderNo: this.info.orderInfoVO.innerOrderNo});
        }).catch(() => {
          this.logisticsCsgApi({id: this.logisticsInfoObj.id, logisticsStatus: 1, innerOrderNo: this.info.orderInfoVO.innerOrderNo});
        });
      }
    },
    closeOrder() {
      this.logisticsInfoObj = {
          id: this.logisticsInfoObj.id,
          logisticsStatus: 2,
          innerOrderNo: this.info.orderInfoVO.innerOrderNo
      };
      this.logisticsCsgApi(this.logisticsInfoObj);
    },
    afterFetchOriginalData(data) {
      this.suspendStatus = data.content[0].suspendStatus;
    },
    handleShippingLabelSaveSuccess() {
      this.isOrderInfoVOEdit = false;
      setTimeout(() => {
        this.$message.success(this.$t('toast.operationSuccessText'));
        this.reFresh();
        // 重新获取物流信息数据
        this.$refs.LogisticsInfo.reFreshDeliverTable();
      }, 1000);
    },
    // 重复运单号二次确认，用户核实后携带确认参数重新提交
    async submitWithDuplicateTrackingConfirm(request, data) {
      const initialData = { ...data };
      delete initialData.duplicateTrackingConfirmed;
      let response = await request(initialData);
      if (response && response.failed === true && response.type === 'warn' && response.code === DUPLICATE_TRACKING_CODE) {
        try {
          await this.$confirm(this.$t('InternalSalesOrderDetails.duplicateTrackingConfirm'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('InternalSalesOrderDetails.duplicateTrackingVerified'),
            cancelButtonText: this.$t('InternalSalesOrderDetails.duplicateTrackingBack'),
            customClass: 'duplicate-tracking-confirm',
            type: 'warning',
          });
        } catch (error) {
          return null;
        }
        response = await request({ ...initialData, duplicateTrackingConfirmed: true });
      }
      if (response && response.failed) {
        this.$message.error(response.message || response.code);
        return null;
      }
      return response;
    },
    // 提交 shipping label数据
    async saveShippingLabelInfo() {
      let fileUrlList = [];
      if (this.fileList.length > 0) {
        fileUrlList = this.fileList.map(item => {
          return { name: item.name, url: item.url };
        });
      }
      if (this.info.orderInfoVO.shippingMethod === 'CSG MANUAL') {
        // 不需要报价 或 报价已确认
        if(!(!this.info.orderInfoVO.isNeedQuota||this.info.orderInfoVO.quotaOrNot==2))
        return this.$message.error(this.$t('WarehouseManagement.form.Quotenot'))
      }else if(this.info.orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'){
        // 在上传面单之前 如果 需要尺寸信息 那么 未填写尺寸信息 则 无法上传面单
        // 不需要尺寸 或 已填写尺寸
        if(!(!this.info.orderInfoVO.isProvideSize||[this.info.orderInfoVO.repLength,this.info.orderInfoVO.repWidth,this.info.orderInfoVO.repHeight,this.info.orderInfoVO.repWeight].every(e=>{return e > 0})))
        return this.$message.error(this.$t('WarehouseManagement.form.not'))
      }
      const data = {
        ...this.logisticsInfoObj,
        outerOrderNo: this.info.orderInfoVO.outerOrderNo,
        innerOrderNo: this.info.orderInfoVO.innerOrderNo
      };
      const DATA = {
        innerOrderNo: this.info.orderInfoVO.innerOrderNo,
        shippingMethod: this.info.orderInfoVO.shippingMethod,
        shippingLabels: JSON.stringify(fileUrlList)
      };
      const status8DATA = {
        innerOrderNo: this.info.orderInfoVO.innerOrderNo,
        logisticsBusinessName: this.logisticsInfoObj.logisticsBusinessName,
        logisticsCompany: this.logisticsInfoObj.logisticsCompany,
        logisticsNo: this.logisticsInfoObj.logisticsNo,
        outerOrderNo: this.orderInfoVO.outerOrderNo,
        shippingLabels: JSON.stringify(fileUrlList),
        totalOrderStatus: this.routeStatus,
        totalPrice: this.logisticsInfoObj.totalPrice,
      };
      if (this.routeStatus === 8) {
        if(this.fileList.length == 0){
          return this.$message.error(this.$t('ExcelConfig.upload'))
        }
        if(this.info.orderInfoVO.shippingMethod === 'CSG MANUAL'){
          if (!this.logisticsInfoObj.logisticsNo || !this.logisticsInfoObj.logisticsBusinessName || !this.logisticsInfoObj.totalPrice) {
            return this.$message.warning(`${this.$t('InternalReturnRefundNoteDetails.Logistics')} ${this.$t('billingPage.Carrie')+this.$t('BusinessOrderAuditComSkuList.transPrice')} ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')} ${this.$t('emptyWarningText')}`);
          }
          const response = await this.submitWithDuplicateTrackingConfirm(orderApi.waitingUpdateLabel, status8DATA);
          if (response) this.handleShippingLabelSaveSuccess();
        }
        if(this.info.orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'){
          if(!this.logisticsInfoObj.logisticsNo || !this.logisticsInfoObj.logisticsBusinessName){
            return this.$message.error(`${this.$t('InternalReturnRefundNoteDetails.Logistics')} ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')} ${this.$t('emptyWarningText')}`);
          }
          const response = await this.submitWithDuplicateTrackingConfirm(orderApi.waitingUpdateLabel, status8DATA);
          if (response) this.handleShippingLabelSaveSuccess();
        }
      }else{
        if (this.info.orderInfoVO.shippingMethod === 'CSG MANUAL') {
          if (!this.logisticsInfoObj.logisticsBusinessName || !this.logisticsInfoObj.totalPrice) {
            return this.$message.warning(this.$t('InternalSalesOrderDetails.errMsgText'));
          }
          if(this.logisticsInfoObj.totalPrice>300){
            this.$confirm(this.$t('InternalSalesOrderDetails.shippingCost'), this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
            }).then(async()=>{
              if (!await this.logisticsCsgApi(data)) return;
              if (!await this.shippingInfoApi(DATA)) return;
              this.handleShippingLabelSaveSuccess();
            })
          }else{
            if (!await this.logisticsCsgApi(data)) return;
            if (!await this.shippingInfoApi(DATA)) return;
            this.handleShippingLabelSaveSuccess();
          }
        } else if(this.info.orderInfoVO.shippingMethod === 'CUSTOMER MANUAL'){
          if(this.logisticsInfoObj.logisticsNo && !this.logisticsInfoObj.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
          if(fileUrlList.length>0 && !this.logisticsInfoObj.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
          data.totalPrice = 0
          if (!await this.logisticsCsgApi(data)) return;
          if (!await this.shippingInfoApi(DATA)) return;
          this.handleShippingLabelSaveSuccess();
        } else {
          if (!await this.shippingInfoApi(DATA)) return;
          this.handleShippingLabelSaveSuccess();
        }
      }
    },
    // 修改CSG手动订单物流信息
    async logisticsCsgApi(data) {
      const response = await this.submitWithDuplicateTrackingConfirm(orderApi.updateOrderLogisticsCsg, data);
      if (!response) return false;
      this.logisticsInfoObj.logisticsStatus = data.logisticsStatus;
      return true;
    },
    // 订单运输信息修改
    async shippingInfoApi(data) {
      const response = await orderApi.modifyShippingInfo(data);
      return !(response && response.failed);
    },
    showOrderInfoVOEdit() {
      this.isOrderInfoVOEdit = true;
      if (this.info.orderInfoVO.shippingLabels) {
        this.$nextTick(() => {
          if (!this.$refs.UploadFileRef) return;
          this.$refs.UploadFileRef.fileList = this.info.orderInfoVO.shippingLabels;
        });
      }
    },
    // 上传的文件列表
    fileListChange(file) {
      this.fileList = file.filter(item => item.url);
    },
    customerDelivery() {
      if(this.orderInfoVO.shippingMethod.toLowerCase().includes("csg manual") && !this.logisticsInfoObj.logisticsNo){
        return this.$message.warning(this.$t('InternalOrder.ps2'));
      }
      this.$refs.delveryDialogRef.dialogVisible = true;
      this.$refs.delveryDialogRef.selectedRows = [this.orderInfoVO.innerOrderNo];
      // 获取当前时间
      const now = new Date();
      const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1);
      this.$refs.delveryDialogRef.pickerOptions = {
        disabledDate(time) {
          // 如果选择的时间小于本周一的时间，则禁用
          if(new Date(item.receiveTime).getTime() > startOfWeek.getTime()){
            return time.getTime() < new Date(item.receiveTime).getTime();
          }else{
            return time.getTime() < startOfWeek.getTime();
          }
        },
      }
    },
    // 获取物流下拉信息
    async getLogisticsDataList() {
      logisticApi.getLogisticsBusiness({
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res => {
        this.LogisticsSelectionData = res.content.map(item => {
          return {
            label: item.logisticsName,
            value: item.name
          };
        });
      });
    },
    // 选择物流信息后执行方法
    logsome(v, item) {
      orderApi.modifyLogistics({
        isLogisticsSpecified: this.info.isLogisticsSpecified == true ? '1' : '0',
        logisticsName: v,
        innerOrderNo: this.orderInfoVO.innerOrderNo
      });
    },
    // 关闭选择物流信息后执行方法
    offSwitch() {
      if (!this.info.isLogisticsSpecified) {
        orderApi.modifyLogistics({
          isLogisticsSpecified: '0',
          logisticsName: null,
          innerOrderNo: this.orderInfoVO.innerOrderNo
        });
      }
    },
    // 是否自提单 开关方法
    switchPickUp() {
      if (this.info.takingDeliveryWay) {
        orderApi.modifyIsPickUp({
          orderCode: this.orderInfoVO.innerOrderNo,
          takingDeliveryWay: 1,
        });
      } else {
        orderApi.modifyIsPickUp({
          orderCode: this.orderInfoVO.innerOrderNo,
          takingDeliveryWay: 2,
        });
      }
    },
    onEditReceiverInfo() {
      this.isReciverEdit = true;
      this.copyReceiverInfo = JSON.parse(JSON.stringify(this.info.receiverInfoVO));
    },
    cancelReceiverInfo() {
      this.isReciverEdit = false;
      this.info.receiverInfoVO = this.copyReceiverInfo;
    },
    saveReceiverInfo(newReceiverInfo, closeDialog) {
      if (newReceiverInfo) {
        this.info.receiverInfoVO = Object.assign({}, this.info.receiverInfoVO, newReceiverInfo);
      }
      const receiverInfoVO = this.info.receiverInfoVO;
      const countryList = ['TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS']
      const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
      if ( this.info.orderInfoVO.shippingMethod != 'PICKUP' ){
        if (!receiverInfoVO.receiverName) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryName')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.phone) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPhone')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.country) return this.$message.warning(`${this.$t('WarehouseManagement.form.country')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.province && !countryList.includes(receiverInfoVO.country)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.province && !regex.test(receiverInfoVO.province)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')}${this.$t('IncorrectAddressFormatText')}`);
        if (!receiverInfoVO.district) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.district && !regex.test(receiverInfoVO.district)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')}${this.$t('IncorrectAddressFormatText')}`);
        if (!receiverInfoVO.zipCode) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPostcode')}${this.$t('emptyWarningText')}`);
        if (!receiverInfoVO.deliveryAddress1) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.deliveryAddress1 && !regex.test(receiverInfoVO.deliveryAddress1)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')}${this.$t('IncorrectAddressFormatText')}`);
        // if (!receiverInfoVO.deliveryAddress2) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')}${this.$t('emptyWarningText')}`);
        if (receiverInfoVO.deliveryAddress2 && !regex.test(receiverInfoVO.deliveryAddress2)) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')}${this.$t('IncorrectAddressFormatText')}`);
        if (receiverInfoVO.deliveryEmailAddress) {
          if (!receiverInfoVO.deliveryEmailAddress.includes('@')) return this.$message.warning(this.$t('personal.emailErrorMsg2'));
        }
      }else{
        if (receiverInfoVO.province) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryState')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.district) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliverySuburb')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.zipCode) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryPostcode')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.deliveryAddress1) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress1')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.deliveryAddress2) return this.$message.warning(`${this.$t('ExternalOrders.newAdd.DeliveryAddress2')} ： ${this.$t('ExternalOrders.addressTips')}`);
        if (receiverInfoVO.deliveryEmailAddress) {
          if (!receiverInfoVO.deliveryEmailAddress.includes('@')) return this.$message.warning(this.$t('personal.emailErrorMsg2'));
        }
      }
      orderApi.updateBuyerInfo({...this.info.receiverInfoVO, innerOrderNo: this.orderInfoVO.innerOrderNo}).then(res => {
        console.log(res,'info');
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.isReciverEdit = false;
          this.$refs.LogisticsInfo.reFreshDeliverTable();
          // 验证通过，关闭弹窗
          closeDialog && closeDialog();
        }
      });
      // 原接口，暂时弃用
      // orderApi.modifyReceiverinfo({...this.info.receiverInfoVO, innerOrderNo: this.orderInfoVO.innerOrderNo}).then(() => {
      //   this.isReciverEdit = false;
      //   this.$refs.LogisticsInfo.reFreshDeliverTable();
      // });
    },
    // 获取物流业务
    getLogistics() {
      this.logistics_visible = true;
      this.getLogisticsConfigByShopCode();
    },
    // 根据网店code获取网店物流配置列表
    getLogisticsConfigByShopCode() {
        channelApi.getLogisticsConfigByShopCode({ shopCode: this.orderInfoVO.storeCode }).then(res => {
          this.dialogListConfig.columns = res;
      });
    },
    handleScroll(vertical, horizontal, nativeEvent) {
    },
    scrollCallBack() {
      // 兼容性，获取页面滚动距离
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 获取浏览器高度
      const windowHeight = window.innerHeight;

      // 判断开始浮动
      const StartFixedHeight = getComputedStyle(
        document.getElementsByClassName('app-container')[0],
      )['paddingTop'].replace('px', '');
      this.isFixed = scrollTop > StartFixedHeight;

      // tabs浮动后，占位
      const placeholderTabs = document.getElementById('placeholderTabs'); // 这是一个占位元素，高度与tab相等，用于tab脱离文档流后，用此占位，防止抖动
      const TabsHeight = document.getElementsByClassName('tabs')[0].offsetHeight || 0;
      placeholderTabs.style.height = this.isFixed ? TabsHeight + 'px' : '0px';

      // 标签的active回写
      this.catalogue.forEach((v, i) => {
        // 获取元素本身离文档顶部高度（这个数据不会改变）
        const offsetTop = getOffsetTop(document.getElementById(`${v.id}`));
        // 如果  元素本身离文档顶部高度offsetTop  - dom滚动距离 =  元素当前离浏览器（可视）顶部的距离
        // 元素当前离浏览器（可视）顶部的距离如果不到2/3屏（到底部为1/3屏），则激活标签
        if (offsetTop - scrollTop < windowHeight / 2) {
          // 导航栏背景色选中
          this.activeName = v.id;
        }
      });
    },
    /* ************************ 按钮事件 *****************************/
    // 取消订单
    onCancel() { // sapOrderStatus 0正在推送sap，1推送成功，6取消sap中，2已发货
      let messageTip = this.$t('InternalSalesOrderDetails.want');
      if (this.orderInfoVO.sapPushTime) {
        messageTip = this.$t('InternalSalesOrderDetails.OrderAwaiting1');
      }
      if (this.orderInfoVO.sapOrderStatus == 2) {
        messageTip = this.$t('InternalSalesOrderDetails.orderShipped');
      }
      this.$confirm(messageTip).then(_ => {
          if (!['CUSTOMER MANUAL', 'CSG MANUAL', 'PICKUP'].includes(this.orderInfoVO.shippingMethod)) {
            this.$refs.LogisticsInfo.CancelLogistics();
          }
          if (this.routeStatus === 3) {
            // 当订单状态为 处理中订单 时 ==>  判断是否可以编辑
            orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(this.orderInfoVO.innerOrderNo) }).then(res => {
              if (res.failed === false) {
                orderApi.cancelInternalOrder({ innerOrderNo: this.orderInfoVO.innerOrderNo }).then(res => {
                  if (res.failed === false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.reFresh();
                    }, 500);
                  }
                });
              }
            });
          } else {
            orderApi.cancelInternalOrder({ innerOrderNo: this.orderInfoVO.innerOrderNo }).then(res => {
              if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          }
      });
    },

    // 取消SAP订单
    CancelSAPOrder() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          orderApi
            .cancelInternalSAPOrder({ innerOrderNo: this.orderInfoVO.innerOrderNo })
            .then(res => {
              if (res.failed === false) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
        })
        .catch(_ => {});
    },

    command(TEXT) {
      this.$confirm(this.$t('InternalSalesOrderDetails.Operation'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          // 仅退款单页面
          if (TEXT === this.$t('InternalSalesOrderDetails.Create')) {
            this.$router.push({
              name: 'BusinessAfterInternalRefundAdd',
              query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
            });
          }
          // 重发单页面
          if (TEXT === this.$t('InternalSalesOrderDetails.Resend')) {
            orderApi.getResendList({outerOrderNo: this.orderInfoVO.outerOrderNo}).then(res => {
              if (res.length) {
                this.isShow = true;
                const arr = res;
                this.viewData = arr;
              } else {
                this.$router.push({
                name: 'BusinessThirdCopyOrderView',
                query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
              });
              }
            });
          }
          // 补发单页面
          if (TEXT === this.$t('InternalSalesOrderDetails.Reissue')) {
            this.$router.push({
              name: 'BusinessThirdReissueOrderView',
              query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
            });
          }
        })
        .catch(() => {});
    },
    // 跳转外部详情页
    goThirdView(e) {
      this.$toBusinessThirdOrderView(e, false);
    },
    // 跳转重发单
    goCopyPage() {
      this.$router.push({
      name: 'BusinessThirdCopyOrderView',
      query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
      });
    },

    tabClick({ name }) {
      const fixedHeaderHeight =
        document.getElementsByClassName('fixed-header')[0].offsetHeight || 0;
      const tabsHeight = document.getElementsByClassName('tabs')[0].offsetHeight || 0;

      const setDocumentScrollFn = v => {
        document.documentElement.scrollTop = v;
      };
      const ANCHOR = document.getElementById(name);
      const TO_DISTANCE = getOffsetTop(ANCHOR) - fixedHeaderHeight - tabsHeight;
      const FROM_DISTANCE = document.documentElement.scrollTop;
      let nowDistance = FROM_DISTANCE;
      const step = 50;
      smoothFn();
      function smoothFn() {
        if (FROM_DISTANCE < TO_DISTANCE) {
          nowDistance += step;
          if (nowDistance < TO_DISTANCE) {
            setTimeout(smoothFn, 10);
          } else {
            nowDistance = TO_DISTANCE;
          }
          setDocumentScrollFn(nowDistance);
        } else {
          nowDistance -= step;
          setDocumentScrollFn(nowDistance);
          if (nowDistance > TO_DISTANCE) {
            setTimeout(smoothFn, 10);
          } else {
            nowDistance = TO_DISTANCE;
          }
          setDocumentScrollFn(nowDistance);
        }
      }
    },
    /* ************************ 按钮事件 *****************************/
    reFresh(goodsInfoActiveTab) {
      const orderId = this.$route.query.id;
      const orderCode = decodeURIComponent(this.$route.query.code);

      orderApi.getInternalDetailByIdCode({
        orderCode,
        orderId,
      }).then(res => {
        this.info = {
          ...this.info,
          ...(res || {}),
          takingDeliveryWay: res.orderInfoVO.takingDeliveryWay == 1,
          isLogisticsSpecified: res.orderInfoVO.isLogisticsSpecified == 1,
        };
        this.info.orderInfoVO.shippingLabels = res.orderInfoVO.shippingLabels ? JSON.parse(res.orderInfoVO.shippingLabels) : [];
        // 通过长宽高重是否有值来判断，尺寸是否填写
        this.sizeIsFillIn = [this.info.orderInfoVO.repLength,this.info.orderInfoVO.repWidth,this.info.orderInfoVO.repHeight,this.info.orderInfoVO.repWeight].every(e=>{return e > 0})
        if (this.manual.includes(this.orderInfoVO.shippingMethod.toUpperCase())) {
          events_config.trigger('getDataOfSearchEvent', false);
        } else {
          events_config.trigger('getDataOfSearchEvent', true);
        }
        this.getImg();
        this.getPaymentInfo();
      });

      this.reTabs(goodsInfoActiveTab);
    },
    changeTabs(tab, event) {
      this.$refs.carousel.setActiveItem(tab.name);
    },
    reTabs(goodsInfoActiveTab) {
      this.tabVisible = false;
      this.$nextTick(() => {
        this.tabVisible = true;
        this.$nextTick(() => {
          if (goodsInfoActiveTab) this.$refs.GoodsInfoTab.goodsInfoActiveTab = goodsInfoActiveTab;
        });
      });
    },
    /* 关闭弹窗 */
    handleClose() {
      this.cancel();
      // if([5,6].includes(this.$route.query.status)){
      //   this.complete('BusinessOrderInternalCSGAdmin');
      // }else{
      //   this.complete('BusinessAbnormalOrderALL');
      // }
    },
    /** 挂起/解挂 */
    onHangUp(action) {
      this.$refs.SuspendReason.onEdit(action);
    },

    /** 添加标签 */
    onAddTags(action) {
      this.$refs.EditTags.onEdit();
    },
    /** 删除一个标签 */
    handleCloseTag(code) {
      this.$confirm(this.$t('InternalSalesOrderDetails.delete'))
        .then(_ => {
          const POST_DATA = this.cptOrderTagCodeList.filter(e => e !== code);
          this.editBaseInfoApi({ orderId: this.id, tags: POST_DATA.join() });
        })
        .catch(_ => {});
    },
    onEditOrder() {
      if (this.routeStatus === 3) {
        // 判断是否可以编辑
        orderApi.getOrderSapStatus({ innerOrderNo: encodeURIComponent(this.orderInfoVO.innerOrderNo) }).then(res => {
          if (res.failed === false) {
            this.$router.push({
              // 内部订单编辑页
              name: 'BusinessOrderInternalEditCSG',
              query: { innerOrderNo: this.orderInfoVO.innerOrderNo, orderHandleStatus: this.routeOrderHandleStatus },
            });
          }
        });
      } else {
        this.$router.push({
          name: 'BusinessOrderInternalEditCSG',
          query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
        });
      }
    },
    onCopy() {
      if (this.orderInfoVO.innerOrderNo) {
        this.$router.push({
          name: 'BusinessOrderInternalAddCSG',
          query: { innerOrderNo: this.orderInfoVO.innerOrderNo },
        });
      } else {
        this.$message.warning(
          this.$t('InternalSalesOrderDetails.error') + this.orderInfoVO.innerOrderNo,
        );
      }
    },
    // {{$t('InternalSalesOrderDetails.Modify')}}备注
    OrderRemarks(key) {
      this.$refs.EditRemarks.onEdit(key);
    },
    onConfirmReceipt() {
      this.$confirm(this.$t('InternalSalesOrderDetails.sure'))
        .then(_ => {
          this.confirmReceiptByOrderIdApi({ orderId: this.id });
        })
        .catch(_ => {});
    },
    // 编辑标签
    editBaseInfoApi(POST_DATA) {
      orderApi.updateOrderBase(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.$refs.EditRemarks.dialogVisible = false;
          this.$refs.EditReceiverInfo.dialogVisible = false;
          this.$refs.EditTags.dialogVisible = false;
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 订单级-确认收货
    confirmReceiptByOrderIdApi(POST_DATA) {
      orderApi.confirmReceiptByOrderId(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 异常原因提示弹出框
    OrderAbnormal() {
      settingApi.getTaskInstanceMessage({innerOrderNo: this.orderInfoVO.innerOrderNo}).then(res => {
        const str = res.exceptionMessage;
        const str1 = str.substring(str.indexOf('\r\n'), str.indexOf('\n\t'));
        this.$alert(str1, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        type: 'warning',
        callback: action => {},
      });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container .bj-form-item .order-remark-content {
  display: flex;
  align-items: center;
  min-width: 0;
}
.order-remark-content .order-remark-text {
  flex: 0 1 auto;
  width: auto;
  max-width: 75%;
  min-width: 0;
}
.order-remark-copy {
  flex: 0 0 auto;
  margin-left: 10px;
}
::v-deep .el-carousel__arrow {
  display: none !important;
}
.app-container-2022-2-9-11-42-08 {
  .status-now {
    font-size: 16px;
    div {
      font-size: 16px;
    }
    .bj-form-item-value {
      font-size: 18px;
    }
  }
  .app-container {
    width: 100%;
  }
}
.circulation-status {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding-bottom: 16px;
  .el-icon-circle {
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 52px;
  }
}
.tabs {
  background-color: white;
}
.tabs .tabs-btn {
  position: absolute;
  right: 20px;
  margin-top: 6px;
  z-index: 1;
}
.isFixed {
  position: fixed;
  top: 86px;
  left: 180px;
  right: 0;
  z-index: 5; // 要小于顶部导航栏的 z-index: 9
  padding: 0 20px;
  z-index: 99;
}
.isFixed2 {
  position: fixed;
  top: 60px;
  left: 140px;
  right: 0;
  z-index: 5; // 要小于顶部导航栏的 z-index: 9
  padding: 30px 20px 0;
}
.file {
  display: flex;
  font-size: 12px !important;
}
.file .fileUpload {
  margin-left: 10px;
  line-height: 20px;
  color: #6c6c6c;
}
.fileUpload_right {
  display: flex;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  margin-left: 5px;
}
::v-deep .avatar-uploader .el-upload {
  border: none;
}
.fileUpload2 {
  margin: 10px 10px 0;
  width: 500px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.flex-box-item {
  flex: 1 1 calc(50% - 8px);
  box-sizing: border-box;
}
</style>
